var map = {
	"./alvara/alvara.module": [
		"./src/app/alvara/alvara.module.ts",
		"common",
		"alvara.module"
	],
	"./area-formacao/area-formacao.module": [
		"./src/app/area-formacao/area-formacao.module.ts",
		"common",
		"area-formacao.module"
	],
	"./certidao-cnaipj/certidao-cnaipj.module": [
		"./src/app/certidao-cnaipj/certidao-cnaipj.module.ts",
		"common",
		"certidao-cnaipj.module"
	],
	"./certidao/certidao.module": [
		"./src/app/certidao/certidao.module.ts",
		"common",
		"certidao.module"
	],
	"./conselho-regional/conselho-regional.module": [
		"./src/app/conselho-regional/conselho-regional.module.ts",
		"common",
		"conselho-regional.module"
	],
	"./consultar-cnaipj/consultar-cnaipj.module": [
		"./src/app/consultar-cnaipj/consultar-cnaipj.module.ts",
		"common",
		"consultar-cnaipj.module"
	],
	"./consultar-comunicacao/consultar-comunicacao.module": [
		"./src/app/consultar-comunicacao/consultar-comunicacao.module.ts",
		"common",
		"consultar-comunicacao.module"
	],
	"./consultar-pessoa-fisica/consultar-pessoa-fisica.module": [
		"./src/app/consultar-pessoa-fisica/consultar-pessoa-fisica.module.ts",
		"common",
		"consultar-pessoa-fisica.module"
	],
	"./consultar-pessoa-juridica/consultar-pessoa-juridica.module": [
		"./src/app/consultar-pessoa-juridica/consultar-pessoa-juridica.module.ts",
		"common",
		"consultar-pessoa-juridica.module"
	],
	"./consultar-situacao-cadastral/consultar-situacao-cadastral.module": [
		"./src/app/consultar-situacao-cadastral/consultar-situacao-cadastral.module.ts",
		"common",
		"consultar-situacao-cadastral.module"
	],
	"./curso/curso.module": [
		"./src/app/curso/curso.module.ts",
		"common",
		"curso.module"
	],
	"./delegacia/delegacia.module": [
		"./src/app/delegacia/delegacia.module.ts",
		"common",
		"delegacia.module"
	],
	"./fila-servico/fila-servico.module": [
		"./src/app/fila-servico/fila-servico.module.ts",
		"common",
		"fila-servico.module"
	],
	"./gerenciar-servico-gestor/gerenciar-servico-gestor.module": [
		"./src/app/gerenciar-servico-gestor/gerenciar-servico-gestor.module.ts",
		"common",
		"gerenciar-servico-gestor.module"
	],
	"./gerenciar-servico-pessoa-juridica/gerenciar-servico-pessoa-juridica.module": [
		"./src/app/gerenciar-servico-pessoa-juridica/gerenciar-servico-pessoa-juridica.module.ts",
		"common",
		"gerenciar-servico-pessoa-juridica.module"
	],
	"./gerenciar-servico/gerenciar-servico.module": [
		"./src/app/gerenciar-servico/gerenciar-servico.module.ts",
		"common",
		"gerenciar-servico.module"
	],
	"./homologacao-cnaipj/homologacao-cnaipj.module": [
		"./src/app/homologacao-cnaipj/homologacao-cnaipj.module.ts",
		"common",
		"homologacao-cnaipj.module"
	],
	"./instituicao-ensino/instituicao-ensino.module": [
		"./src/app/instituicao-ensino/instituicao-ensino.module.ts",
		"common",
		"instituicao-ensino.module"
	],
	"./natureza-titulo/natureza-titulo.module": [
		"./src/app/natureza-titulo/natureza-titulo.module.ts",
		"common",
		"natureza-titulo.module"
	],
	"./oficio/oficio.module": [
		"./src/app/oficio/oficio.module.ts",
		"common",
		"oficio.module"
	],
	"./orgao-expedidor/orgao-expedidor.module": [
		"./src/app/orgao-expedidor/orgao-expedidor.module.ts",
		"common",
		"orgao-expedidor.module"
	],
	"./pessoa-fisica/pessoa-fisica.module": [
		"./src/app/pessoa-fisica/pessoa-fisica.module.ts",
		"common"
	],
	"./pessoa-juridica/pessoa-juridica.module": [
		"./src/app/pessoa-juridica/pessoa-juridica.module.ts",
		"common"
	],
	"./profissao/profissao.module": [
		"./src/app/profissao/profissao.module.ts",
		"common",
		"profissao.module"
	],
	"./registros-delegacia/registros-delegacia.module": [
		"./src/app/registros-delegacia/registros-delegacia.module.ts",
		"common",
		"registros-delegacia.module"
	],
	"./solicitacao-cnaipj/solicitacao-cnaipj.module": [
		"./src/app/solicitacao-cnaipj/solicitacao-cnaipj.module.ts",
		"common",
		"solicitacao-cnaipj.module"
	],
	"./solicitar-comunicacao/solicitar-comunicacao.module": [
		"./src/app/solicitar-comunicacao/solicitar-comunicacao.module.ts",
		"common",
		"solicitar-comunicacao.module"
	],
	"./validar-documentos/validar-documentos.module": [
		"./src/app/validar-documentos/validar-documentos.module.ts",
		"common",
		"validar-documentos.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main